//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.SheetMetal.js";
import "../no/Object.js";
import "../Features/Features.FeatureCollection.js";
let d=[[],[[["aerosm_flange"],"CreateFlangeBuilder",{R_:{builder:"Features.SheetMetal.AeroFlangeBuilder"}},1,0],[["aerosm_joggle"],"CreateJoggleBuilder",{R_:{builder:"Features.SheetMetal.AeroJoggleBuilder"}},1,0],[["aerosm_unform"],"CreateUnformBuilder",{R_:{builder:"Features.SheetMetal.AeroUnformBuilder"}},1,0],[["aerosm_reform"],"CreateReformBuilder",{R_:{builder:"Features.SheetMetal.AeroReformBuilder"}},1,0],[["aerosm_unform"],"CreateFlatSolidBuilder",{R_:{builder:"Features.SheetMetal.FlatSolidBuilder"}},1,0],[["aero_lightening_cutout"],"CreateAeroLighteningCutoutBuilder",{R_:{builder:"Features.SheetMetal.AeroLighteningCutoutBuilder"}},1,0],[["aerosm_unform"],"CreateFlatPatternBuilder",{R_:{builder:"Features.SheetMetal.FlatPatternBuilder"}},1,0]],[]];
SPLM.Features.SheetMetal.AeroSheetmetalManager = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Features.SheetMetal.AeroSheetmetalManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;